import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CalendarModule, DialogModule, SharedModule, DataTableModule } from 'primeng/primeng';
import { BusinessManageDialogComponent } from '../business-manage/business-manage-dialog/business-manage-dialog.component';
import { CompanyFormComponent } from '../company-form/company-form.component';
import { PurchaseSearchComponent } from '../plan/purchase-search/purchase-search.component';
import { QuotationSearch2Component } from '../plan/quotation-search/quotation-search-2/quotation-search-2.component';
import { QuotationSearchComponent } from '../plan/quotation-search/quotation-search.component';
import { SettingDialogComponent } from '../setting-dialog/setting-dialog.component';
import { NewcarModalComponent } from './../newcar/newcar-modal/newcar-modal.component';
import { CalendarDateComponent } from './components/calendar-date/calendar-date.component';
import { DialogloginComponent } from './components/dialoglogin/dialoglogin.component';
import { DropdowncalendarComponent } from './components/dropdowncalendar/dropdowncalendar.component';
import { FooterComponent } from './components/footer/footer.component';
import { DialogStaffloginComponent } from './components/header/dialog-stafflogin/dialog-stafflogin.component';
import { HeaderComponent } from './components/header/header.component';
import { LoaderComponent } from './components/loader/loader.component';
import { NumberInputComponent } from './components/number-input/number-input.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { OnlyNumber } from './directives/onlynumber.directive';
import { PasswordBoxDirective } from './directives/password-box.directive';
import { Select } from './directives/select.directive';
import { ZeroFillDirective } from './directives/zero-fill.directive';
import { PasswordsPipe } from './pipes/passwords.pipe';
import { SlashDatePipe } from './pipes/slash-date.pipe';
import { AutofocusDirective } from './directives/focus.directive';
import { OsusumeDropdownComponent } from '../osusume/osusume-dropdown/osusume-dropdown.component';
import { OsusumeSettingComponent } from '../osusume/osusume-setting/osusume-setting.component';
import { OsusumeAddComponent } from '../osusume/osusume-add/osusume-add.component';
import { OsusumeEditComponent } from '../osusume/osusume-edit/osusume-edit.component';
import { JapDatePipe } from './pipes/jap-date.pipe';
import { DialogmessengerComponent } from './components/dialogmessenger/dialogmessenger.component';
import { PaginatorsComponent } from '../shared/components/paginators/paginators.component';
import { DragulaModule } from 'ng2-dragula';
import { CarSearchComponent } from '../plan/car-search/car-search.component';
import { EquipmentModalComponent } from '../plan/equipment-modal/equipment-modal.component';
import { DetailModalComponent } from '../plan/detail-modal/detail-modal.component';
import { DialogMaxEquipmentComponent } from '../plan/dialog-max-equipment/dialog-max-equipment.component';
import { NumcommaPipe } from '../shared/pipes/numcomma.pipe';
import { NewInformationComponent } from './components/new-information/new-information.component';
import { DialogMaxlengthComponent } from '../shared/components/dialog-maxlength/dialog-maxlength.component';
import { ContactBarComponent } from '../contact-bar/contact-bar.component';
import { Angular2FontawesomeModule } from 'angular2-fontawesome';
import { DialogUsedcarComponent } from '../usedcar/dialog-usedcar/dialog-usedcar.component';
@NgModule({
  imports: [
    CommonModule,
    Angular2FontawesomeModule,
    RouterModule,
    DialogModule,
    FormsModule,
    CalendarModule,
    SharedModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
    DragulaModule,
    DataTableModule,
    PaginationModule.forRoot()
  ],
  declarations: [
    PasswordsPipe,
    HeaderComponent,
    FooterComponent,
    DialogloginComponent,
    NewcarModalComponent,
    DialogStaffloginComponent,
    BusinessManageDialogComponent,
    SettingDialogComponent,
    PurchaseSearchComponent,
    CompanyFormComponent,
    SlashDatePipe,
    DropdowncalendarComponent,
    QuotationSearch2Component,
    CalendarDateComponent,
    QuotationSearchComponent,
    PaginationComponent,
    ZeroFillDirective,
    NumberInputComponent,
    LoaderComponent,
    Select,
    PasswordBoxDirective,
    AutofocusDirective,
    OsusumeDropdownComponent,
    OsusumeSettingComponent,
    OsusumeAddComponent,
    OsusumeEditComponent,
    OnlyNumber,
    PasswordBoxDirective,
    JapDatePipe,
    DialogmessengerComponent,
    PaginatorsComponent,
    CarSearchComponent,
    EquipmentModalComponent,
    DetailModalComponent,
    DialogMaxEquipmentComponent,
    NumcommaPipe,
    NewInformationComponent,
    DialogMaxlengthComponent,
    ContactBarComponent,
    DialogUsedcarComponent
  ],
  exports: [
    DialogmessengerComponent,
    PasswordsPipe,
    HeaderComponent,
    FooterComponent,
    DialogloginComponent,
    NewcarModalComponent,
    DialogStaffloginComponent,
    BusinessManageDialogComponent,
    PurchaseSearchComponent,
    SlashDatePipe,
    DropdowncalendarComponent,
    QuotationSearch2Component,
    CalendarDateComponent,
    QuotationSearchComponent,
    PaginationComponent,
    NumberInputComponent,
    LoaderComponent,
    Select,
    AutofocusDirective,
    OsusumeDropdownComponent,
    OsusumeSettingComponent,
    OsusumeAddComponent,
    OsusumeEditComponent,
    OnlyNumber,
    PaginatorsComponent,
    JapDatePipe,
    CarSearchComponent,
    EquipmentModalComponent,
    DetailModalComponent,
    DialogMaxEquipmentComponent,
    NumcommaPipe,
    NewInformationComponent,
    DialogMaxlengthComponent,
    ContactBarComponent,
    DialogUsedcarComponent
  ]
})
export class ShareModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts